import { forwardRef, type InputHTMLAttributes, type ReactNode } from 'react';
import './Switch.css';

export interface SwitchProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label: ReactNode;
}

/** A real native `<input type="checkbox" role="switch">`, visually a toggle.
 * Announces "on"/"off" via the native checked state — no separate ARIA
 * live-region wiring needed since `role="switch"` handles the semantics. */
export const Switch = forwardRef<HTMLInputElement, SwitchProps>(function Switch(
  { label, className, id, ...rest },
  ref
) {
  return (
    <label className={['dpr-switch', className].filter(Boolean).join(' ')}>
      <input ref={ref} type="checkbox" role="switch" id={id} className="dpr-switch__input" {...rest} />
      <span className="dpr-switch__track" aria-hidden="true">
        <span className="dpr-switch__thumb" />
      </span>
      <span className="dpr-switch__label">{label}</span>
    </label>
  );
});
